import React, {useContext} from "react";

import DiscountsPopupContentDropdowns from "./DiscountsPopupContentDropdowns";
import {getCurrentWorkSheetSections, getParsedWizardLogic} from "../discountsFunctions";
import {setDiscountSections, setWorkSheetsActiveIndex, setWorkSheetsCount} from "../discountsActions";
import {setUiPopupState} from "../../../actions/A_Popups";
import {getFabricatorSubscriptions} from "../../NewScope/newScopeActions";
import {connect} from "react-redux";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";


const DiscountsPopupContent = () => {

  const {uiPopupContext} = useContext(UIPopupContext);

  return (
    <div className="flex flex--column flex-item pl-1 pr-1 pt-1">
      {uiPopupContext.currentSheetSections && uiPopupContext.currentSheetSections.length
        ? <DiscountsPopupContentDropdowns/>
        : (
          <div className="flex flex--center height-100 width-100 font--16 text-center">
            No price worksheet items found. <br/> Please create a discount to assign display logic.
          </div>
        )}
      {/*<div className="fs-toggle-popup__table scrollbar3 flex-item padding-t0">*/}
      {/*  <ul className="fix-ul">*/}
      {/*    {displayOptions.map(displayOption => {*/}
      {/*      return (*/}
      {/*        <li key={displayOption.forWizardId + displayOption.forWizardHashId + displayOption.forWizardGroupId}*/}
      {/*            className="fs-toggle-popup__table-row bordered flex flex--between flex--center padding-t0">*/}
      {/*          <div className="flex-item text-overflow">*/}
      {/*            <div className="secondary">Visualizer: <span className="color-green bold text-capitalize">*/}
      {/*              {displayOption.forVisualizer}*/}
      {/*            </span></div>*/}
      {/*            <div className="secondary">Wizard: <span className="color-green bold">*/}
      {/*              {displayOption.forWizardName}*/}
      {/*            </span></div>*/}
      {/*            <div className="secondary">Wizard Group Name: <span className="color-green bold">*/}
      {/*              {displayOption.forWizardGroupId + ". " + (displayOption.forWizardGroupTitle || displayOption.forWizardGroupName)}*/}
      {/*            </span></div>*/}
      {/*          </div>*/}
      {/*          <button className="ui-icon-close ui-icon-close--red ui-icon-close--small height-20 relative top-3 flex-icon-24"*/}
      {/*                  onClick={() => removeGroupSelection(displayOption)}/>*/}
      {/*        </li>*/}
      {/*      )*/}
      {/*    })}*/}
      {/*  </ul>*/}
      {/*</div>*/}
    </div>
  )
};

export default DiscountsPopupContent
